export const BILLING_SUBACTIVITIES = ["RES", "BAR", "CDR"] as const;

export type BillingSubactivity = (typeof BILLING_SUBACTIVITIES)[number];
export type FiscalActivity = BillingSubactivity | "NON" | "HAB";

const FISCAL_ACTIVITIES: FiscalActivity[] = ["RES", "BAR", "CDR", "NON", "HAB"];

export function isFiscalActivity(value: unknown): value is FiscalActivity {
  return FISCAL_ACTIVITIES.includes(value as FiscalActivity);
}

export function storeBillingSubactivity(store?: { billingSubactivity?: string } | null): BillingSubactivity {
  const value = store?.billingSubactivity;
  if (value === "BAR" || value === "CDR") return value;
  return "RES";
}

export function lineItemActi(
  storeActivity: BillingSubactivity,
  itemActivity: string,
  unitPrice: number,
): BillingSubactivity | "SOB" | "NON" | "HAB" {
  if (!Number.isFinite(unitPrice) || unitPrice === 0) return "SOB";
  if (itemActivity === "NON" || itemActivity === "HAB") return itemActivity;
  return storeActivity;
}

export function billingActivityChoices(storeActivity: BillingSubactivity, current?: string): FiscalActivity[] {
  const activities: BillingSubactivity[] = storeActivity === "BAR"
    ? ["BAR", "RES", "CDR"]
    : storeActivity === "CDR"
      ? ["CDR", "RES", "BAR"]
      : ["RES", "BAR", "CDR"];
  const base: FiscalActivity[] = [...activities, "NON", "HAB"];
  if (current && isFiscalActivity(current) && !base.includes(current)) return [current, ...base];
  return base;
}
